import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { FETCH_ASSOCIATIONS } from '../constants/asyncActionTypes';
import { fetchThreadAssociations } from '../clients/fetchThreadAssociations';
export const fetchAssociations = createAsyncAction({
  requestFn: fetchThreadAssociations,
  actionTypes: FETCH_ASSOCIATIONS,
  toRecordFn: associations => ImmutableSet(associations.map(ImmutableMap))
});